export default class URLUtils {

    static getURL(path) {

        let url = window.location.origin;

        if (path.charAt(0) == '/') {
            url += path;
        } else {
            url += window.location.pathname;
            url = url.slice(0, url.lastIndexOf('/'));
            url += '/' + path;
        }

        return url;
    }

}
